import {sample} from 'effector';
import {combine, merge} from 'effector/effector.cjs';

import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    createCustomsFx,
    data$,
    defaultFilters,
    defaultSortings,
    editCustomsData$,
    fetchDataFx,
    filters$,
    filtersChanged,
    filtersReset,
    Gate,
    onSetEditCustoms,
    pageNumber$,
    pageSize$,
    removeCustomsFx,
    search$,
    searchChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
    tableStateChanged,
    updateCustomsFx,
} from './index';

pageNumber$.reset(filtersChanged, sortingsChanged, stateReset);
pageSize$.reset(stateReset);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

data$.on(fetchDataFx.doneData, (_, data) => data).reset(Gate.close);
editCustomsData$.on(onSetEditCustoms, (_, payload) => payload);

sample({
    clock: merge([
        tableStateChanged,
        searchChanged,
        createCustomsFx.done,
        removeCustomsFx.done,
        Gate.open,
    ]),
    source: combine({
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
        sortings: sortings$,
        searchField: search$,
    }),
    fn: ({pageNumber, pageSize, filters, sortings, searchField}) => ({
        paging: {pageNumber, pageSize},
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
        searchField,
    }),
    target: fetchDataFx,
});

createCustomsFx.doneData.watch(() =>
    toast.success(i18next.t('pages.customs.create.messages.create')),
);
updateCustomsFx.doneData.watch(() =>
    toast.success(i18next.t('pages.customs.create.messages.update')),
);
removeCustomsFx.doneData.watch(() =>
    toast.success(i18next.t('pages.customs.create.messages.remove')),
);

[fetchDataFx, createCustomsFx, updateCustomsFx, removeCustomsFx].forEach((fx) =>
    fx.failData.watch((err) => showRestError(err as RestError)),
);
